import { render, staticRenderFns } from "./club-roles.vue?vue&type=template&id=1a0326ca&scoped=true&"
import script from "./club-roles.vue?vue&type=script&lang=js&"
export * from "./club-roles.vue?vue&type=script&lang=js&"
import style0 from "./club-roles.vue?vue&type=style&index=0&id=1a0326ca&lang=scss&scoped=true&"
import style1 from "./club-roles.vue?vue&type=style&index=1&id=1a0326ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0326ca",
  null
  
)

export default component.exports